import React, { useEffect } from 'react';

export const SimpleCriticalCSS: React.FC = () => {
  useEffect(() => {
    // Inyectar CSS crítico agresivo inmediatamente
    const injectCriticalCSS = () => {
    const criticalCSS = `
      /* Critical CSS - Statemia - Aggressive */
      * { box-sizing: border-box; }
      html { 
        background-color: #ffffff !important;
        color: #000000 !important;
      }
      body { 
        margin: 0 !important; 
        background-color: #ffffff !important;
        color: #000000 !important;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-height: 100vh;
      }
      /* Force light theme - prevent dark mode */
      .dark { display: none !important; }
      [data-theme="dark"] { display: none !important; }
      /* Prevent any dark backgrounds - ONLY for loading state */
      .loading-state div, .loading-state section, .loading-state article, .loading-state main, .loading-state header, .loading-state footer {
        background-color: #ffffff !important;
        color: #000000 !important;
      }
      /* Override any potential dark styles - ONLY for loading state */
      .loading-state .bg-background { background-color: #ffffff !important; }
      .loading-state .bg-gray-900 { background-color: #ffffff !important; }
      .loading-state .bg-black { background-color: #ffffff !important; }
      .loading-state .text-white { color: #000000 !important; }
      .loading-state .text-gray-100 { color: #000000 !important; }
      .min-h-screen { min-height: 100vh; }
      .flex { display: flex; }
      .flex-1 { flex: 1 1 0%; }
      .flex-col { flex-direction: column; }
      .hidden { display: none; }
      .items-center { align-items: center; }
      .justify-center { justify-content: center; }
      .justify-between { justify-content: space-between; }
      .relative { position: relative; }
      .sticky { position: sticky; }
      .top-0 { top: 0px; }
      .z-50 { z-index: 50; }
      .w-full { width: 100%; }
      .h-full { height: 100%; }
      .block { display: block; }
      .hidden { display: none; }
      .overflow-hidden { overflow: hidden; }
      .rounded-lg { border-radius: 0.5rem; }
      .shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }
      .transition-all { transition: all 0.2s ease; }
      .hover\\:scale-105:hover { transform: scale(1.05); }
      .text-white { color: white; }
      .text-foreground { color: #000000; }
      .text-muted-foreground { color: #6b7280; }
      .bg-white { background-color: white; }
      .bg-background { background-color: #ffffff !important; }
      .border { border: 1px solid #e5e7eb; }
      .p-4 { padding: 1rem; }
      .p-6 { padding: 1.5rem; }
      .mb-4 { margin-bottom: 1rem; }
      .mb-6 { margin-bottom: 1.5rem; }
      .mb-8 { margin-bottom: 2rem; }
      .text-4xl { font-size: 2.25rem; line-height: 2.5rem; }
      .text-2xl { font-size: 1.5rem; line-height: 2rem; }
      .text-lg { font-size: 1.125rem; line-height: 1.75rem; }
      .font-bold { font-weight: 700; }
      .font-semibold { font-weight: 600; }
      .font-medium { font-weight: 500; }
      .grid { display: grid; }
      .grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
      .gap-6 { gap: 1.5rem; }
      .loading-skeleton {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite;
      }
      @keyframes loading {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
      /* Centered Spinner */
      .centered-spinner-container {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        background-color: #ffffff !important;
        z-index: 9999 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      /* Hide footer during loading */
      .loading-state footer {
        display: none !important;
      }
      .centered-spinner {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .spinner {
        width: 40px !important;
        height: 40px !important;
        border: 4px solid #f3f4f6 !important;
        border-top: 4px solid #10b981 !important;
        border-radius: 50% !important;
        animation: spin 1s linear infinite !important;
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .featured-article-skeleton {
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 0.5rem;
        overflow: hidden;
        padding: 1.5rem;
      }
      .space-y-3 > * + * {
        margin-top: 0.75rem;
      }
      .h-64 { height: 16rem; }
      .h-6 { height: 1.5rem; }
      .h-4 { height: 1rem; }
      .w-3\\/4 { width: 75%; }
      .w-2\\/3 { width: 66.666667%; }
      .w-1\\/2 { width: 50%; }
      .rounded { border-radius: 0.25rem; }
      @media (min-width: 640px) {
        .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .sm\\:text-5xl { font-size: 3rem; line-height: 1; }
      }
      @media (min-width: 768px) {
        .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .md\\:flex-row { flex-direction: row; }
        .md\\:items-center { align-items: center; }
      }
      @media (min-width: 1024px) {
        .lg\\:block { display: block; }
        .lg\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .lg\\:text-6xl { font-size: 3.75rem; line-height: 1; }
      }
    `;

      // Crear elemento style si no existe
      let styleElement = document.getElementById('critical-css');
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'critical-css';
        styleElement.textContent = criticalCSS;
        document.head.appendChild(styleElement);
      }
    };

    // Inyectar inmediatamente
    injectCriticalCSS();
    
    // También inyectar en el próximo tick para asegurar
    setTimeout(injectCriticalCSS, 0);
  }, []);

  return null; // Este componente no renderiza nada
};

export default SimpleCriticalCSS;
